import React from 'react';
import { IAnswerGroup, IAnswerMapping } from '../QuestionnairePrintView.service';

interface IPhoneNumberTemplateProps {
  answerGroups: IAnswerGroup[];
}

const PHONE = {
  COUNTRY_CODE: '0',
  AREA_CODE: '1',
  PHONE_NUMBER_1: '2',
  PHONE_NUMBER_2: '3',
  IS_PRIMARY: '4',
} as const;

const PhoneNumberTemplate: React.FC<IPhoneNumberTemplateProps> = ({ answerGroups }) => {
  const getFieldValue = (answerMapping: Record<string, IAnswerMapping>, fieldKey: string): string => {
    return answerMapping[fieldKey]?.answerForQuestion || '';
  };

  const formatPhoneNumber = (answerMapping: Record<string, IAnswerMapping>): string => {
    const countryCode = getFieldValue(answerMapping, PHONE.COUNTRY_CODE);
    const areaCode = getFieldValue(answerMapping, PHONE.AREA_CODE);
    const phoneNumber1 = getFieldValue(answerMapping, PHONE.PHONE_NUMBER_1);
    const phoneNumber2 = getFieldValue(answerMapping, PHONE.PHONE_NUMBER_2);

    return `${countryCode} +${areaCode} ${phoneNumber1} ${phoneNumber2}`;
  };

  const isPrimaryPhone = (answerMapping: Record<string, IAnswerMapping>): boolean => {
    return getFieldValue(answerMapping, PHONE.IS_PRIMARY) === 'yes';
  };

  return (
    <div>
      {answerGroups.map((group, index) => {
        const { answerMapping } = group;

        return (
          <div key={index} className="flex items-center">
            <p>{formatPhoneNumber(answerMapping)}</p>
            {isPrimaryPhone(answerMapping) && <i className="ml-1"> (Primary)</i>}
          </div>
        );
      })}
    </div>
  );
};

export default PhoneNumberTemplate;
